
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/docs/signal/creating-signal-items",
      function () {
        return require("private-next-pages/docs/signal/creating-signal-items.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/docs/signal/creating-signal-items"])
      });
    }
  